import { forwardRef } from "react"

const Score = forwardRef(function Score({error, ...props}, ref) {
  const klass = "text-md text-center border rounded-lg block w-[55px] p-1 bg-white border-gray-300 text-gray-900 focus:ring-primary-600 focus:border-primary-600"

  return (
    <input
      ref={ref}
      className={klass}
      {...props}
    />
  )
})

export default Score;
